<loading [isLoading]="isLoading" [success]="loadingSuccess"></loading>
<ng-template #deckTemplate></ng-template>

@if (!isVisible) {
    <four-o-four></four-o-four>
}